import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Zap } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Welcome = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [memberNo, setMemberNo] = useState(null);

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (res.data.member_no) {
          setMemberNo(res.data.member_no);
          return;
        }
      } catch {}
      if (++tries < 10) timer = setTimeout(poll, 3000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div data-testid="welcome-page" className="min-h-screen bg-obsidian relative flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 grid-lines" />
      <div className="absolute inset-0 hero-spotlight" />
      <div className="relative max-w-xl mx-auto px-6 text-center">
        <div className="inline-grid place-items-center h-16 w-16 bg-volt text-white mx-auto">
          <Zap className="h-8 w-8" strokeWidth={2.5} />
        </div>
        <div className="mt-8 inline-flex items-center gap-2 border border-volt/40 bg-volt/10 px-4 py-2 font-mono text-[11px] tracking-widest uppercase text-volt">
          <CheckCircle2 className="h-4 w-4" />
          Payment Confirmed
        </div>
        <h1 className="font-display font-black uppercase tracking-tight leading-[0.95] text-4xl sm:text-6xl mt-6">
          Welcome to fit50!<br />
          <span className="text-volt italic">You&rsquo;re in.</span>
        </h1>
        {memberNo && (
          <p data-testid="welcome-member-number" className="mt-5 inline-block border border-volt/50 bg-volt/10 px-5 py-2.5 font-display font-bold uppercase tracking-wide text-lg text-volt">
            You&rsquo;re Founding Member #{memberNo}
          </p>
        )}
        <p className="mt-6 text-base sm:text-lg text-neutral-400 leading-relaxed">
          Download the app to get started.
        </p>
        {sessionId && (
          <p className="mt-6 font-mono text-[10px] tracking-widest uppercase text-neutral-600">
            Order ref: {sessionId.slice(0, 24)}…
          </p>
        )}
        <Link
          data-testid="welcome-home-link"
          to="/"
          className="mt-10 inline-flex items-center gap-3 bg-volt text-white font-display font-bold uppercase tracking-wide text-lg px-8 py-4 hover:bg-volt-hover hover:shadow-[0_0_35px_rgba(255,107,0,0.5)] transition-[background-color,box-shadow] duration-200"
        >
          Back To Fit50
        </Link>
      </div>
    </div>
  );
};
